import React from 'react';
import styled from 'styled-components';

const PageTitle = ({ page_title }) => (
  <Title>{page_title}</Title>
);

const Title = styled.h1`
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 0.5rem;
  letter-spacing: -0.02em;

  @media (max-width: 600px) {
    font-size: 1.375rem;
  }
`;

export default PageTitle;
